export default __webpack_public_path__ + "static/applying-menu-image-b8846dcd3e6a9c01b88472e38d827903.jpg";